import { parseEther, writeContractAndWait, zeroAddress } from "../viem";
import { approveToken, getTokenAllowance } from ".";
import MafiaPerkBoxMinterAbi from "../../abis/MafiaPerkBoxMinter.json";
import config from "../../config/config";
import { delay } from "../../utils/utils";
import { isIndexingTxError } from "../parseTxError";

const address = config.perkBoxMinter;
const abi = MafiaPerkBoxMinterAbi;

export const buyPerkBoxes = async (
  swapTokenId: number,
  tokenAddress: string,
  tokenAmount: number,
  perkBoxAmount: number,
  account: string
) => {
  if (tokenAddress === zeroAddress) {
    const nativeAmount = parseEther(tokenAmount.toFixed(18));

    await writeContractAndWait({
      address,
      abi,
      functionName: "buyPerkBoxes",
      args: [swapTokenId, perkBoxAmount],
      account,
      value: nativeAmount,
    });
  } else {
    const tokenAllowance = await getTokenAllowance(
      tokenAddress,
      account,
      config.perkBoxMinter
    );

    try {
      if (Number(tokenAllowance) < tokenAmount) {
        await approveToken(
          tokenAddress,
          tokenAmount,
          config.perkBoxMinter,
          account
        );
        await delay(config.blockTime);
      }
    } catch (error: any) {
      if (isIndexingTxError(error)) {
        await delay(config.blockTime);
      } else {
        throw error;
      }
    }

    await writeContractAndWait({
      address,
      abi,
      functionName: "buyPerkBoxes",
      args: [swapTokenId, perkBoxAmount],
      account,
    });
  }
};

export const splitPerkBoxes = async (account: string, itemIds: number[]) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "splitPerkBoxes",
    args: [itemIds],
    account,
  });

  return tx;
};
